
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class RallyRoundStatusTable extends Vue {
  @Prop({ default: [] }) statisticData!: []
}
